import { X } from 'lucide-react';
import { Button } from '../atoms/Button';
import { useUIStore } from '@/store/uiStore';
import { useScrollLock } from '@/hooks/useScrollLock';

/**
 * 소셜 로그인 모달 — 3사 버튼만 표시
 * 실제 OAuth 리다이렉트 URL은 백엔드 redirectUri와 동일하게 구성
 */
export function LoginModal() {
  const { loginModalOpen, setLoginModalOpen } = useUIStore();
  useScrollLock(loginModalOpen);
  if (!loginModalOpen) return null;

  const handleSocialLogin = (provider: 'kakao' | 'naver' | 'google') => {
    // 각 provider의 인증 URL로 이동 (백엔드 redirect_uri가 콜백 처리)
    const urls: Record<typeof provider, string> = {
      kakao: `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${import.meta.env.VITE_KAKAO_REST_API_KEY ?? ''}&redirect_uri=${encodeURIComponent('https://community.insidemation.com/auth/callback/kakao')}`,
      naver: `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${import.meta.env.VITE_NAVER_CLIENT_ID ?? ''}&redirect_uri=${encodeURIComponent('https://community.insidemation.com/auth/callback/naver')}&state=${Math.random().toString(36).slice(2)}`,
      google: `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${import.meta.env.VITE_GOOGLE_CLIENT_ID ?? ''}&redirect_uri=${encodeURIComponent('https://community.insidemation.com/auth/callback/google')}&scope=email%20profile`,
    };
    window.location.href = urls[provider];
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={() => setLoginModalOpen(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-sm rounded-2xl bg-[var(--color-surface)] p-6"
      >
        <div className="mb-6 flex items-start justify-between">
          <div>
            <h2 className="text-xl font-bold text-[var(--color-text)]">시세공간 로그인</h2>
            <p className="mt-1 text-sm text-[var(--color-text-sub)]">
              소셜 계정으로 3초 만에 시작하세요
            </p>
          </div>
          <button
            onClick={() => setLoginModalOpen(false)}
            aria-label="닫기"
            className="rounded p-1 hover:bg-[var(--color-bg)]"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-3">
          <Button
            fullWidth
            size="lg"
            className="bg-[#FEE500] !text-[#191919] hover:brightness-95"
            onClick={() => handleSocialLogin('kakao')}
          >
            💬 카카오로 계속하기
          </Button>
          <Button
            fullWidth
            size="lg"
            className="bg-[#03C75A] !text-white hover:brightness-95"
            onClick={() => handleSocialLogin('naver')}
          >
            N 네이버로 계속하기
          </Button>
          <Button
            fullWidth
            size="lg"
            variant="secondary"
            onClick={() => handleSocialLogin('google')}
          >
            G 구글로 계속하기
          </Button>
        </div>

        <p className="mt-6 text-center text-xs text-[var(--color-text-sub)]">
          로그인 시 <a href="/terms" className="underline">이용약관</a> 및{' '}
          <a href="/privacy" className="underline">개인정보처리방침</a>에 동의하는 것으로 간주됩니다.
        </p>
      </div>
    </div>
  );
}
